import type { FC, PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { usePortalUser } from "@/app/hooks";
import { ROUTES } from "@/app/router";
import { EmbeddablesFormContextProvider } from "@/features/embeddables/context";
import { LogoLoader } from "@/shared/components";
import { useAuthStore } from "@/shared/stores";

export const RequireEmbeddablesHealthieAccount: FC<PropsWithChildren> = () => {
  const { data: portalUser, isLoading, isError } = usePortalUser();

  const isLoggedIn = useAuthStore((state) => Boolean(state.token));

  if (isLoading) {
    return <LogoLoader fullscreen variant="secondary" />;
  }

  const isEmbeddablesHealthieAccount = Boolean(
    portalUser?.embeddables && portalUser?.patientId,
  );

  if (!isEmbeddablesHealthieAccount || isError || !isLoggedIn) {
    return <Navigate replace to={ROUTES.BASE} />;
  }

  return <EmbeddablesFormContextProvider />;
};
